import * as React from 'react';
import { TiptapButton } from '../TiptapButton';
import Lift from 'Shared/icons/lift.svg';
import { useEditorContext } from '../../editor_context';

export const IndentButton = props => {
   const { editor } = useEditorContext();

   return (
      <TiptapButton
         onClick={() => editor.chain().focus().sinkListItem('listItem').run()}
         isDisabled={!editor.can().sinkListItem('listItem')}
         icon={<Lift style={{ transform: 'scaleX(-1)' }} />}
         title={_js('Increase indent')}
         overrideShortcut={'tab'}
      />
   );
};
